import React from 'react';
import './LoadingBox.css';

export const LoadingBox = () => {
    return (
      <div className="loading-box">
      </div>
    );
}
